module.exports = __webpack_public_path__ + "img/logo-kids.c989c940.png";